var $571468ea4c85156f$exports = {};
$571468ea4c85156f$exports = {
    "colorFormat": `\u{41A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{43E}\u{432}\u{438}\u{439} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$571468ea4c85156f$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
